import actionTypes from 'SRC/modules/redux/actionTypes'

export const setActiveTab = tab => ({
  type: actionTypes.SET_ADD_AD_ACTIVE_TAB,
  payload: tab
})
